<template>
    <div class="video-txt-ad">
        <div class="video-area" :id="this.id">
            <div class="video-init-mask" v-show="!isPlayed">
                <img class="video-cover" :src="cover"/>
                <div class="video-icon" @click="handlePlay">
                    <svg class="sohu-video-playImg" data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 24"><title>ic_play_s</title><path d="M4.32,23.53C2.5,24.54,1,23.87,1,22V2C1,.13,2.5-.54,4.32.48l17.31,9.67c1.82,1,1.82,2.68,0,3.7Z" transform="translate(-1)"></path></svg>
                </div>
                <div class="video-title">{{ title }}</div>
            </div>
            <a class="video-end-mask"
                v-if="isEnded"
                href="javascript:void(0)"
                :data-jumpUrl="landUrl"
                data-spm-type="content">
                <div class="replay-icon" @click.stop.prevent="replay"></div>
                <div class="replay-button" @click.stop.prevent="replay">重播</div>
                <div class="promotion-area">
                    <img class="icon" :src="promotionIcon" />
                    <div class="text-area">
                        <span class="title">{{ promotionTitle }}</span>
                        <span class="brief">{{ promotionBrief }}</span>
                    </div>
                    <div class="button">立即前往</div>
                </div>
            </a>
        </div>
        <footer v-if="!tagForbid" class="video-info">
            <span class="from">来源：{{ authorName }}</span>
            <span class="tag" :style="tagStyle">{{ tag.name }}</span>
        </footer>
        <a v-else href="javascript:void(0)" :data-jumpUrl="landUrl" class="video-info" ref="videoInfo">
            <span class="from">来源：{{ authorName }}</span>
            <div class="viewMore">
                <span class="text">查看更多</span>
                <span class="icon right-icon"></span>
            </div>
        </a>
    </div>
</template>
<script>
import imgUtil from '../../_utils/pic-util'
import Util from '../../_utils/util'
import Helper from '../../_utils/helper'
import Support from '../../_utils/supporter'
export default{
    name: 'videoTxtAd',
    data(){
        return {
            creatives: [], // 素材数组
            tag: {}, // 标签信息
            tagForbid: false, // 是否禁用标签
            videoPlayer: null, // 当前视频播放器实例
            timeoutTimer: 0, // 定时器id
            isPlaying: false, // 是否正在播放
            isPaused: false, // 是否播放完毕
            isPlayed: false, // 是否播放了，只要开始播放过就为true
            isEnded: false, // 是否播放结束
            scrollFunc: new Function(), // 滑动处理函数
        }
    },
    computed:{
        title(){
            return this?.creatives?.[0]?.title
        },
        videoUrl(){
            console.log('视频源链接', this?.creatives?.[0]?.videoUrl)
            return this?.creatives?.[0]?.videoUrl + '#' + Helper.generateRand(6) // 给url加hash值，避免url重复导致视频状态共享与错乱
        },
        landUrl(){
            return this?.creatives?.[0]?.link
        },
        promotionIcon(){
            return this?.creatives?.[0]?.atrrInfoList?.[0]?.image
        },
        promotionTitle(){
            return this?.creatives?.[0]?.atrrInfoList?.[1]?.text
        },
        promotionBrief(){
            return this?.creatives?.[0]?.atrrInfoList?.[2]?.text
        },
        promotionButton(){
            return this?.creatives?.[0]?.atrrInfoList?.[3]?.text
        },
        authorName(){
            return this?.creatives?.[0]?.authorName
        },
        cover(){
            const realWidth = 355
            const realHeight = 200
            const url = imgUtil.setPicSize(this?.creatives?.[0]?.images?.[0]?.url, realWidth, realHeight)
            return url
        },
        tagStyle(){
            let styleArr = []
            this.tag.boardColor && styleArr.push(`background-color:${this.tag.boardColor}`)
            this.tag.textColor && styleArr.push(`color:${this.tag.textColor}`)
            return styleArr.join(';')
        },
        /**
         * @description 视频挂载点的id
         */
        id(){
            return new Date().getTime() + Helper.generateRand(6)
        }
    },
    mounted() {
        this.initEvent()
    },
    beforeDestroy() {
        this.timeoutTimer && clearTimeout(this.timeoutTimer)
        window.removeEventListener('scroll', this.scrollFunc)
        this.videoPlayer.destroy()
    },
    methods: {
        initEvent(){
            this.$nextTick(()=>{
                const videoContainer = document.getElementById(this.id)
                this.scrollFunc = Util.throttle(()=>{
                    if(Util.isShow(videoContainer)){ // 进入视野
                        console.log('视频广告进入视野',this.id)
                        if(this.isPlaying) return // 滑动时如果已经在播放中则不暂停
                        this.timeoutTimer && clearTimeout(this.timeoutTimer) // 滑动时不断刷新定时器，类似于防抖,用于实现停留两秒后自动播放
                        this.timeoutTimer = setTimeout(()=>{ // 停留两秒，自动静音播放
                            this.handlePlay()
                            clearTimeout(this.timeoutTimer)
                        },2000)
                    }else{
                        this.isPlaying && this.videoPlayer.pause() // 滑出视野时暂停播放
                        this.timeoutTimer && clearTimeout(this.timeoutTimer)
                    }
                },100)
                window.addEventListener('scroll', this.scrollFunc)
                window.MptcfeUtils && window.MptcfeUtils.event && window.MptcfeUtils.event.on('videoPlaying',(playerEleId) => {
                    if(this.id !== playerEleId && this.videoPlayer){
                        console.log('视频',this.id,'销毁')
                        this.videoPlayer.destroy()
                        // 初始化视频播放相关控制字段
                        this.videoPlayer = null
                        if(!this.isEnded){
                            this.isPlaying = false
                            this.isPlayed = false // 不处于结束态，则恢复到初始态，结束态一直展示推广
                            this.isPaused = false
                            this.isEnded = false
                        }
                    }
                })
            })
        },
        initVideoEvent(){
            const videoContainer = document.getElementById(this.id)
            this.videoPlayer.on('play',(data) => {
                console.log('视频播放中',this.id)
                this.isPlaying = true
                this.isPlayed = true
                this.isPaused = false
                this.isEnded = false
                const videoContainer = document.getElementById(this.id)
                const videoElement = videoContainer.querySelector('video')
                videoElement && Support.isUC && ( videoElement.style.display = 'block' ) // UC视频重新播放时展示视频标签
            })
            this.videoPlayer.on('pause', (data) => {
                console.log('视频暂停',this.id)
                this.isPaused = true
                this.isPlaying = false
                this.isEnded  = false
            })
            this.videoPlayer.on('ended', ()=> {
                console.log('视频播放结束',this.id)
                this.isEnded = true
                this.isPlaying = false
                this.isPaused = false
                const originButton = videoContainer.querySelector('.mptc-player-btn-play-big')
                const videoElement = videoContainer.querySelector('video')
                videoElement && Support.isUC && ( videoElement.style.display = 'none' ) // UC视频播放结束后将视频标签隐藏，解决uc代理视频导致推广无法展示问题
                originButton && ( originButton.style.display = 'none')
            })
        },
        replay(){
            const videoContainer = document.getElementById(this.id)
            const videoElement = videoContainer.querySelector('video')
            videoElement && Support.isUC && ( videoElement.style.display = 'block' ) // UC视频重新播放时展示视频标签
            this.handlePlay()
        },
        handlePlay(){
            if(!this.videoPlayer){
                this.$nextTick(()=>{
                    const videoContainer = document.getElementById(this.id)
                    console.log(this.id,'视频挂载',videoContainer)
                    import(/* webpackChunkName: "dynamic4mptcfeWapPlayer" */ 'mptcfe-wap-player').then((res)=>{
                        const MptcPlayer = res.MptcPlayer
                        this.videoPlayer = new MptcPlayer(videoContainer,{
                            src: this.videoUrl,
                            title: this.title,
                            titleShow: false,
                            infoShow: false,
                            poster: this.cover,
                            fullScreen: false,
                            mutedShow: true,
                            showControlImmediate: true, // 打开视频立即展示时间进度条
                            params:{
                                newsId: -1,
                                authorId: -1,
                            }
                        })
                        this.initVideoEvent()
                        this.videoPlayer.play()
                    })
                })
            }else if(this.isPaused){
                this.videoPlayer.continue()
            }else if(this.isEnded){
                this.videoPlayer.play()
            }
            window.MptcfeUtils && window.MptcfeUtils.event && window.MptcfeUtils.event.emit('videoPlaying', this.id)
        }
    },
}
</script>
<style lang="less" scoped>
.video-txt-ad{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .video-area{
        width: 698px;
        height: 400px;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
    }
    .video-info{
        width: 698px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 14px 24px 22px 24px;
        background: #f5f5f5;
        box-sizing: border-box;
        .from{
            height: 24px;
            font-size: 24px !important; /*px*/
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
        }
        .tag{
            height: 30px;
            background: rgba(0,0,0,0.3);
            border-radius: 4px;
            padding:0px 6px;
            box-sizing: border-box;
            font-size: 20px !important; /*px*/
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 30px;
        }
        .viewMore{
            font-size: 0px;
            .text{
                height: 24px;
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FF365C;
                line-height: 24px;
            }
            .right-icon{
                width: 24px;
                height: 24px;
                display: inline-block;
                background: url('../../less/images/icon_right_red@2x.png') no-repeat center;
                background-size: contain;
            }
        }
    }
    .video-init-mask{
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
        z-index: 1;
        box-sizing: border-box;
        .video-cover{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .video-icon{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 108px;
            height: 108px;
            transform: translate(-50%,-50%);
            background: rgba(0,0,0,0.5);
            border-radius: 50%;
            z-index: 1;
            svg{
                width: 29px;
                height: 37px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-40%,-50%);
                color: #FFFFFF;
                fill: #FFFFFF;
            }
        }
        .video-title{
            position: absolute;
            left: 0px;
            bottom: 0px;
            height: 96px;
            width: 100%;
            box-sizing: border-box;
            padding: 0px 24px;
            background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 96px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            z-index: 1;
        }
    }
    .video-end-mask{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;
        background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
        z-index: 1;
        .replay-icon{
            width: 80px;
            height: 80px;
            background: url('../../less/images/icon-replay@2x.png');
            background-size: contain;
            position: absolute;
            top: 76px;
            left: 50%;
            transform: translateX(-50%);
            margin-bottom: 12px;
        }
        .replay-button{
            padding: 0px 22px;
            height: 48px;
            border-radius: 29px;
            border: 2px solid #FFFFFF;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 48px;
            position: absolute;
            top: 168px;
            left: 50%;
            transform: translateX(-50%);
        }
        .promotion-area{
            position: absolute;
            left: 0;
            bottom: 28px;
            height: 72px;
            width: 100%;
            padding-left: 26px;
            box-sizing: border-box;
            display: flex;
            align-items: flex-start;
            .icon{
                width: 72px;
                height: 72px;
                border-radius: 12px;
                margin-right: 12px;
                object-fit: cover;
            }
            .text-area{
                display: inline-flex;
                flex-direction: column;
                flex-wrap: wrap;
                justify-content: center;
                .title{
                    height: 28px;
                    font-size: 28px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 28px;
                    margin-bottom: 12px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 390px;
                }
                .brief{
                    height: 24px;
                    font-size: 24px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    max-width: 390px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .button{
                height: 54px;
                background: linear-gradient(116deg, #FD6B6B 0%, #FF2958 100%);
                border-radius: 29px;
                position: absolute;
                right: 32px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 54px;
                padding: 0px 24px;
            }
        }
    }
}
// 推荐阅读增加padding和分界线
.feed-list-scoped{
    .video-txt-ad{
        padding: 12px 0px;
        border-bottom: 1px solid #f0f0f0;
    }
}
</style>